module.exports = __webpack_public_path__ + "img/Poker_Chip_Gray.dafd4b32.svg";